import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { v4 as uuid4 } from "uuid";

import { environment } from '../../environments/environment';


type UUID = string;  // TODO: Переместить тип в common/types


const API_SERVER = environment.apiServer;


export interface LogRecordRequest {
  XID: UUID;
  CreatedAt: Date;
  Scope: "frontend";
  QualName: string;
  Description: string | null;
  InputParams: string | null;
  Token: string | null;
  State: "start" | "finish" | "error";
  Error: string | null;
}


@Injectable()
export class LoggingService {

  private static readonly ENDPOINT = `${API_SERVER}/monitoring/log`;

  constructor(private _http: HttpClient) { }

  generateUUID(): string {
    return uuid4();
  }

  log(partialRequest: Partial<LogRecordRequest>): Observable<any> {
    let now = new Date();
    now.setHours(now.getHours() + 3);

    const logData: LogRecordRequest = {
      XID: partialRequest.XID || this.generateUUID(),
      CreatedAt: partialRequest.CreatedAt || now,
      Scope: partialRequest.Scope || "frontend",
      QualName: partialRequest.QualName!,
      Description: partialRequest.Description ? partialRequest.Description.substring(0, 512) : null,
      InputParams: partialRequest.InputParams ? partialRequest.InputParams : null,
      Token: partialRequest.Token || null,
      State: partialRequest.State!,
      Error: partialRequest.Error ? partialRequest.Error : null
    };

    return this._http.post(LoggingService.ENDPOINT, logData).pipe();
  }

  logStart(xid: string, qualName: string, inputParams: any = null, message: string | null = null): void {
    this.log({
      XID: xid,
      QualName: qualName,
      InputParams: inputParams ? JSON.stringify(inputParams) : null,
      State: 'start',
      Description: message || `Start ${qualName}`
    }).subscribe();
  }

  logFinish(xid: string, qualName: string, inputParams: any = null, message: string | null = null): void {
    this.log({
      XID: xid,
      QualName: qualName,
      InputParams: inputParams ? JSON.stringify(inputParams) : null,
      State: 'finish',
      Description: message || `Finish ${qualName}`
    }).subscribe();
  }

  logError(xid: string, qualName: string, error: any, inputParams: any = null, message: string | null = null): void {
    this.log({
      XID: xid,
      QualName: qualName,
      InputParams: inputParams ? JSON.stringify(inputParams) : null,
      State: 'error',
      Description: message || `Error in ${qualName}`,
      Error: JSON.stringify({ "type": error.name, "message": error.message, "stack": error.stack })
    }).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/logging.service.ts